var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchBar = function SvgSearchBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search-bar_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48 10.063a.438.438 0 1 0 0 .876.438.438 0 0 0 0-.877M9.854 10.063a.438.438 0 1 0 0 .876.438.438 0 0 0 0-.877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.042 7.875v-1.75a1.75 1.75 0 0 0-1.75-1.75h-21a1.75 1.75 0 0 0-1.75 1.75v7a1.75 1.75 0 0 0 1.75 1.75h6.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.042 21a6.125 6.125 0 1 0 0-12.25 6.125 6.125 0 0 0 0 12.25Z",
    fill: "#FFE1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.792 23.625-4.42-4.42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search-bar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.667)",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgSearchBar;